import ApiDataService from '@/api/apiData.service';
import OptionValueInterface from '@/api/domain/option-value.interface';

class CommonService {
  apiDataService: ApiDataService = new ApiDataService();
  async getObjectiveOptions(): Promise<Array<OptionValueInterface>> {
    return await this.apiDataService.get('/api/v1/common/option/objective');
  }

  async getUpdateFrequencyUnitOptions() {
    return await this.apiDataService.get('/api/v1/common/option/frequency_unit');
  }

  async getGeoCoverageOptions() {
    return await this.apiDataService.get('/api/v1/common/option/geo_coverage');
  }

  async getDataFormatOptions() {
    return await this.apiDataService.get('/api/v1/common/option/format');
  }

  async getDataCategoryOptions() {
    return await this.apiDataService.get('/api/v1/common/option/category');
  }

  async getLicenseTypeOptions() {
    return await this.apiDataService.get('/api/v1/common/option/license');
  }

  async getDataSupportOptions() {
    return await this.apiDataService.get('/api/v1/common/option/support');
  }

  async getDataCollectOptions() {
    return await this.apiDataService.get('/api/v1/common/option/collect');
  }

  async getDataLanguageOptions() {
    return await this.apiDataService.get('/api/v1/common/option/language');
  }

  async getDisaggregateOptions() {
    return await this.apiDataService.get('/api/v1/common/option/disaggregate');
  }

  async getDataTypesOptions() {
    return await this.apiDataService.get('/api/v1/common/option/data_type');
  }

  async getMultiplierUnitOptions() {
    return await this.apiDataService.get('/api/v1/common/option/multiplier_unit');
  }

  async getGeoGraphicOptions() {
    return await this.apiDataService.get('/api/v1/common/option/geographic');
  }

  async getEquivalentScaleOptions() {
    return await this.apiDataService.get('/api/v1/common/option/equivalent_scale');
  }
}
export default CommonService;
